import React from 'react';
// import { PropTypes } from 'prop-types';
import '../Dashboard/styles.scss';
import Icon from '../../componentsV2/Icons/Icon';
import Button from '../../componentsV2/Button/Button';

const HelpPage = () => {
  return (
    <div>
      <div className="flex items-center gap-x-2 pb-16">
        <Icon name="help" />
        <div className="text-40 font-pally font-bold">Help</div>
      </div>
      <div className="ml-9.5">
        <h2 className="text-2xl font-bold pb-2">Resources</h2>
        <p className="pb-4">Let us help you make the most of the app.</p>
        <div className="flex justify-between space-x-6 pb-20">
          <div className="w-1/3 p-4 bg-vamos-white rounded-10px shadow-md flex flex-col justify-between">
            <div className="flex items-center gap-x-2 mb-3">
              <div className=""><Icon name="user_guide" /></div>
              <h3 className="text-md font-bold">User guide</h3>
            </div>
            <p className="flex-grow mb-3">Everything you need to know
              to put Vamos to work.
            </p>
            <a href="https://docs.google.com/document/d/1M7dB9txljYhpIDLA7gDzMoGdD2qVJ7XZcnvUSu7GwUY/edit?usp=sharing" target="#" className="flex items-center justify-center space-x-4 p-2.5 rounded-md bg-vamos-v-light-gray hover:bg-vamos-light-gray">
              <span>View user guide</span>
              <Icon name="arrow_forward" />
            </a>
          </div>
          <div className="w-1/3 p-4 bg-vamos-white rounded-10px shadow-md flex flex-col justify-between">
            <div className="flex items-center gap-x-2 mb-3">
              <div className=""><Icon name="data_guide" /></div>
              <h3 className="text-md font-bold">Data imports guide</h3>
            </div>
            <p className="flex-grow mb-3">General information about
              importing.
            </p>
            <a href="https://docs.google.com/document/d/1wJijOJokFYzAdikGchZh1rD_qg3Wb2Yibpz8Aju8Zpg/edit?usp=sharing" target="#" className="flex items-center justify-center space-x-4 p-2.5 rounded-md bg-vamos-v-light-gray hover:bg-vamos-light-gray">
              <span>View imports guide</span>
              <Icon name="arrow_forward" />
            </a>
          </div>
          <div className="w-1/3 p-4 bg-vamos-white rounded-10px shadow-md flex flex-col justify-between">
            <div className="flex items-center gap-x-2 mb-3">
              <div className=""><Icon name="lightbulb" /></div>
              <h3 className="text-md font-bold">Training site</h3>
            </div>
            <p className="flex-grow mb-3">
              Connect to all our user materials including training videos.
            </p>
            <a href="https://codethedream.org/vamos-training/" target="#" className="flex items-center justify-center space-x-4 p-2.5 rounded-md bg-vamos-v-light-gray hover:bg-vamos-light-gray">
              <span>View training site</span>
              <Icon name="arrow_forward" />
            </a>
          </div>
        </div>
        <div className="border-t border-vamos-blue-gray pb-12" />
        <h2 className="text-2xl font-bold pb-2">Request form</h2>
        <p className="pb-4">Have an idea for a feature? Find a bug?</p>
        <div className="rounded-10px shadow-md ">
          <iframe title="Future/Bug Form" src="https://airtable.com/embed/app8EC0NO7FrnAMlP/shrJYzImLvfS9S9Jd" className="w-full h-42rem border-0" />
        </div>
        <div className="py-20">
          <h2 className="text-2xl font-bold">Couldn’t find what you need?</h2>
          <div className="flex justify-between ">
            <p className="py-2">Get in touch and let us know how we can help.</p>
            <Button
              label="Contact us"
              size="lg"
              onClick={() => { window.location.href = 'mailto:vamos@codethedream.org'; }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HelpPage;

HelpPage.propTypes = {
};

